import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * If a password recovery link lands on "/" (or any other route) with
 * #access_token=...&type=recovery, we redirect to /reset-password while
 * preserving the hash so the reset screen can validate the session.
 */
export function RecoveryRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.hash) return;

    const hash = location.hash.startsWith("#") ? location.hash.slice(1) : location.hash;
    const params = new URLSearchParams(hash);

    const type = params.get("type");
    const accessToken = params.get("access_token");

    if (type !== "recovery" || !accessToken) return;
    if (location.pathname === "/reset-password") return;

    navigate(
      {
        pathname: "/reset-password",
        search: location.search,
        hash: location.hash,
      },
      { replace: true }
    );
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}
